import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/authContext";

const PrivateRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // ✅ Prevents flickering while checking auth

  return user ? <Outlet /> : <Navigate to="/" state={{ from: location }} replace />;
};

export default PrivateRoute;
